<template>
  <v-navigation-drawer
    fixed
    permanent
    :mini-variant="true"
    :mini-variant-width="60"
    class="white sidebar"
  >
  <div class="person-selector-container">
    <div
      v-for="person in people"
      :key="person.fName + person.lName"
      @click="selectPerson(person)"
      :class="[person === selectedPerson ? 'selected-person' : '', 'person']"
    >
      <div class="person-image-holder temp-name-container">
        <img
          src="https://cdn.vuetifyjs.com/images/cards/road.jpg"
          class="person-image"
        >
        <div class="temp-name-text">{{person.fName}}</div>
      </div>
    </div>
  </div>
  </v-navigation-drawer>
</template>

<script>
export default { 
  data: () => {
    return {
      firstSelection: true,
    }
  },
  props: ["people"],
  methods: {
    selectPerson(person){
      this.firstSelection = false;
      this.$emit("selectPerson", person);
    },
    scrollToSelectedPerson() {
      const el = this.$el.getElementsByClassName('selected-person')[0];

      if (el) {
        el.scrollIntoView();
      }
    }
  },
  mounted(){
    this.firstSelection = true;
  },
  computed: {
    selectedPerson() {
      // TODO !! This feels like a pretty hacky way to do this... but it works
      // If this is the first selection this time the component mounted, scroll to the person
      if(this.firstSelection){
        this.$nextTick(() => this.scrollToSelectedPerson())
      }
      return this.$store.getters.people[this.$store.getters.selectedPersonKey];
    },
  }
};
</script>
<style scoped>
.sidebar{
  position: fixed;
  top: 64px !important;
  left: 80px;
  z-index: 9;
  height: calc(100% - 64px) !important;
}
.sidebar-list{
  padding-top: 0px;
}
.person-selector-container{
  height: 100%;
  width: 100%;
  padding-bottom: 64px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.person-selector-container::-webkit-scrollbar {
  display: none;
}
.person-image-holder{
  padding: 0% 10%;
  margin: 10px 0px;
  display: flex;
  align-content: center;
}
.person-image{
  width: 100%;
  border-radius: 50%;
}
.person{
  cursor: pointer;
}
.selected-person{
  background-color: rgb(218, 218, 218);
}

.temp-name-container{
  position: relative;
}
.temp-name-text{
  position:absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/People/PersonSelector.vue